'use strict';

module.exports = [{
    pattern: /Apple Computer, Inc\./i,
    name: 'Apple'
}, {
    pattern: /Google Inc\./i,
    name: 'Google'
}];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@browser-detection/dist/lib/vendors.js
// module id = 705
// module chunks = 0